import { createStore } from "@reduxjs/toolkit";
import getUrlGetParam from "../utils/getUrlGetParam";
import axios from "axios";
import getUrlTokenParam from "../utils/getUrlTokenParam";

const btnSubscribe = $('.unsubscribe #btn-unsubscribe');
const checkboxesSubscribeType = $(".unsubscribe [name='subscribe-type']");
const isAgreeCheckbox = document.querySelector('.b-form__politic.unsubscribe input[name="agree_checkbox"]');

// Инициализация состояния с учётом начальных значений чекбоксов
const initialState = {
  email: getUrlGetParam('email'),
  checkboxes: (() => {
    let isOneCheckboxActive = false;
    let value = [];
    checkboxesSubscribeType.each((i, elem) => {
      if ($(elem).is(':checked')) {
        isOneCheckboxActive = true;
        value.push($(elem).val());
      }
    });
    return {
      isChosen: isOneCheckboxActive && isAgreeCheckbox.checked,
      value
    };
  })()
};

function validationReducer(state = {...initialState}, action) {
  switch (action.type) {
    case 'updateCheckboxes':
      return {
        ...state,
        checkboxes: action.payload
      };
    default:
      return state;
  }
}

const store = createStore(validationReducer);

// Обновляем кнопку при изменении состояния
store.subscribe(() => {
  const { isChosen } = store.getState().checkboxes;
  btnSubscribe.prop('disabled', !isChosen);
});

// Обработчики изменений для всех связанных элементов
const updateStore = () => {
  store.dispatch({
    type: 'updateCheckboxes',
    payload: getCheckboxesValue()
  });
};

checkboxesSubscribeType.on('change', updateStore);
$(isAgreeCheckbox).on('change', updateStore);

// Отправка формы
btnSubscribe.click(function() {
  axios.post('/api/unsubscribe/', {
    lang: window.lang,
    md5: getUrlTokenParam(),
    checkboxes: store.getState().checkboxes.value
  }).then(res => {
    $('.pvs-content-card').html(res.data.result);
  }).catch(err => {
    console.error('Unsubscribe error:', err);
  });
});

// Получение текущих значений чекбоксов
const getCheckboxesValue = () => {
  let isOneCheckboxActive = false;
  const value = [];

  checkboxesSubscribeType.each((i, elem) => {
    if ($(elem).is(':checked')) {
      isOneCheckboxActive = true;
      value.push($(elem).val());
    }
  });

  return {
    isChosen: isOneCheckboxActive && isAgreeCheckbox.checked,
    value
  };
};